import { GridColDef } from "@mui/x-data-grid-pro";

import dayjs from "dayjs";

/**
 * GenerateOrdemCompraConsultarPrecosColumnDefinition
 */

type Props = {
};

export const GenerateOrdemCompraConsultarPrecosColumnDefinition = ({
}: Props): GridColDef[] => {
  return [
    {
      field: "nrOrdemCompra",
      filterable: false,
      headerName: "Nº OC",
      minWidth: 45,
      width: 45,
      sortable: false,
      renderCell: (params) => {
        return (
          <div className="w-full h-full flex justify-center items-center text-center text-[0.65rem] py-2">
            {params.value}
          </div>
        );
      }
    },
    {
      field: "dataRef",
      filterable: false,
      headerName: "Data OC",
      width: 75,
      minWidth: 75,
      sortable: false,
      renderCell: ({ value }) => (
        <div className="w-full h-full flex justify-center items-center text-center text-[0.65rem] py-2">
          <span>{value && dayjs.utc(value).local().format('DD/MM/YYYY')}</span>
        </div>
      ),
    },
    {
      field: "nomeFantasia",
      filterable: false,
      headerName: "Fornecedor",
      width: 260,
      minWidth: 260,
      sortable: false,
      renderCell: (params) => {
        return (
          <div className="w-full h-full flex justify-center items-center text-center text-[0.65rem] py-2">
            {params.value}
          </div>
        );
      }
    },
    {
      field: "centroCusto",
      filterable: false,
      headerName: "Centro de Custo",
      width: 240,
      minWidth: 240,
      sortable: false,
      renderCell: (params) => {
        return (
          <div className="w-full h-full flex justify-center items-center text-center text-[0.65rem] py-2">
            {params.value}
          </div>
        );
      }
    },
    {
      field: "materialServico",
      filterable: false,
      headerName: "Produto/Serviço",
      flex: 1,
      minWidth: 150,
      sortable: false,
      renderCell: (params) => {
        return (
          <div className="w-full h-full flex justify-center items-center text-center text-[0.65rem] py-2">
            {params.value}
          </div>
        );
      }
    },
    {
      field: "subconta",
      filterable: false,
      headerName: "Subconta",
      width: 190,
      minWidth: 190,
      sortable: false,
      renderCell: (params) => {
        return (
          <div className="w-full h-full flex justify-center items-center text-center text-[0.65rem] py-2">
            {params.value}
          </div>
        );
      }
    },
    {
      field: "valorUnitario",
      filterable: false,
      headerName: "Valor Unitário",
      width: 90,
      minWidth: 90,
      sortable: false,
      renderCell: ({ value }) => (
        <div className="w-full h-full flex justify-center items-center text-center text-[0.65rem] py-2">
          <span>{value && `R$ ${value.toFixed(2).replaceAll('.', ',')}`}</span>
        </div>
      ),
    },
    {
      field: "quantidade",
      filterable: false,
      headerName: "Quantidade",
      minWidth: 80,
      width: 80,
      sortable: false,
      renderCell: ({ value }) => (
        <div className="w-full h-full flex justify-center items-center text-center text-[0.65rem] py-2">
          <span>{value && value.toFixed(2).replaceAll('.', ',')}</span>
        </div>
      ),
    },
    {
      field: "valorTotal",
      filterable: false,
      headerName: "Valor Total",
      width: 90,
      minWidth: 90,
      sortable: false,
      renderCell: ({ value }) => (
        <div className="w-full h-full flex justify-center items-center text-center text-[0.65rem] py-2">
          <span>{value && `R$ ${value.toFixed(2).replaceAll('.', ',')}`}</span>
        </div>
      ),
    },
  ];
}